export const user = {
    types: {
        admin: "Administrator",
        manager: "Manager",
        technical: "Technician",
    },
    labels: {
        uninformed: "Not Informed",
        password: "Password",
        confirm_password: "Confirm Password",
    },
    placeholders: {
        password: "Enter Password",
        confirm_password: "Confirm Password",
    },
    modals: {
        titles: {
            user_add: "Add User",
            user_remove: "Remove User",
        },
        messages: {
            user_remove: "Are you sure you want to remove the user <strong>{name}</strong>?<br/>This action cannot be undone.",
        }
    }
};
